import {NgModule} from '@angular/core';
import {MatSelectSearchComponent} from './mat-select-search.component';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        TranslateModule
    ],
    declarations: [
        MatSelectSearchComponent
    ],
    exports: [
        MatInputModule,
        MatSelectSearchComponent
    ]
})
export class MatSelectSearchModule {
}
